import React, { useCallback, useState } from "react";
import { useNavigate } from "react-router-dom";

import FilePreviewSideModal from "../../../modals/FilePreviewSideModal";
import { isEmpty, isNil } from "lodash";
import AssociationChip from "./AssociationChip";

const AssociationChipsByIds = ({
  loan,
  ids,
  config,
  onDelete,
  disableDelete,
}) => {
  const navigate = useNavigate();
  const [previewFile, setPreviewFile] = useState(null);

  const getItemById = useCallback(
    (id) => {
      if (!config.getLoanData) {
        console.warn(
          `AssociationChipsByIds: config.getLoanData is not defined for ${config.key}`
        );
        return null;
      }

      try {
        const items = config.getLoanData(loan);

        if (isNil(items)) {
          return null;
        }

        return items?.find((item) => item?._id === id);
      } catch (error) {
        console.error(
          `Error getting item by ID in AssociationChipsByIds:`,
          error
        );
        return null;
      }
    },
    [loan, config]
  );

  const handleOnClick = useCallback(
    (id) => {
      try {
        if (config.usePreview) {
          const item = getItemById(id);
          if (item) {
            setPreviewFile(item);
          }
        } else {
          if (config.getNavigationUrl) {
            const url = config.getNavigationUrl(loan, id);
            if (url) {
              navigate(url);
            }
          }
        }
      } catch (error) {
        console.error("Error handling click in AssociationChipsByIds:", error);
      }
    },
    [loan, config, navigate, getItemById]
  );
  // Early return for missing required data
  if (isNil(loan)) {
    console.warn("AssociationChipsByIds: loan is null or undefined");
    return null;
  }

  if (isNil(config)) {
    console.warn("AssociationChipsByIds: config is null or undefined");
    return null;
  }

  if (isEmpty(ids)) {
    return null;
  }

  return (
    <>
      {ids.map((id) => {
        if (isNil(id)) {
          return null;
        }

        const item = getItemById(id);

        // Get label with fallback
        let label = "Unknown";
        if (item && config.getLabel) {
          try {
            label = config.getLabel(item) || "Unknown";
          } catch (error) {
            console.error("Error getting label:", error);
          }
        }

        return (
          <AssociationChip
            key={id}
            attachmentId={id}
            background={config.background || "#f5f5f5"}
            color={config.color || "#333"}
            icon={config.icon}
            onClick={() => handleOnClick(id)}
            onDelete={disableDelete ? null : onDelete}
          >
            {label}
          </AssociationChip>
        );
      })}

      {config.usePreview && previewFile && (
        <FilePreviewSideModal
          loan={loan}
          file={previewFile}
          onClose={() => setPreviewFile(null)}
        />
      )}
    </>
  );
};
export default AssociationChipsByIds;
